
import { useEffect } from 'react'

import { Flex, Text, useColorModeValue } from '@chakra-ui/react';

import CenteredAuth from 'layouts/publico/variants/Centered';

import TerminosCondiciones from 'components/text/TerminosCondiciones';

export default function Default() {    
	useEffect(() => document.title = `Taurel - Servicios en Línea - Terminos y Condiciones de Uso`,[]);

	const textColor = useColorModeValue('secondaryGray.900', 'white');
	return (
		<CenteredAuth
			image={'linear-gradient(135deg, #337ab7 0%, #12518a 100%)'}
			cardTop={{ base: '140px', md: '14vh' }}
			cardBottom={{ base: '50px', lg: 'auto' }}
			mx='0px'>
			<Flex
				maxW={{ base: '100%', md: 'max-content' }}
				mx={{ base: 'auto', lg: '0px' }}
				me='auto'
				justifyContent='center'
				px={{ base: '20px', md: '0px' }}
				flexDirection='column'>
				<Flex direction='column' color='white' h='100%' w='100%' mb={{ base: '20px', md: '0px' }}>
					<Text  color={textColor}
						mt={{ base: '10px', md: '0px' }}
						mb='20px'
						fontSize={{ base: '2xl', md: '32px', lg: '44px', xl: '44px' }}
						fontWeight='bold'>
						Terminos y Condiciones de Uso
					</Text>
				</Flex>
				<TerminosCondiciones />
			</Flex>
		</CenteredAuth>
	);
}
